import { types } from 'mobx-state-tree';
import { demoPages } from '../menu';
import AlarmService from '../services/AlarmService';
import get from 'lodash/get';

const NotificationList = types
    .model({
        id: types.optional(types.number, 0),
        title: types.optional(types.string, ''),
        date: types.optional(types.string, ''),
        data: types.optional(types.string, ''),
        message: types.optional(types.string, ''),
        type: types.optional(types.string, ''),
        read: types.optional(types.boolean, false),
        createdAt: types.optional(types.string, ''),
    })

export const Notifiction = types
    .model('Notifiction', {
        isOpen: types.optional(types.boolean, false),
        badge: types.optional(types.number, 0),
        list: types.optional(types.array(NotificationList), []),
    })
    .views((self) => ({
		get get() {
            return {...self}
		},
	}))
    .actions((self) => ({
        async setData(data) {
			self.list = data;
		},
        async setBadge(no) {
            self.badge = no;
        },
        async getRefresh(companyId) {
            await AlarmService.alarm(companyId).then( res => {
                const data = get(res, 'data.list', []);
                self.setData(data);
                self.setBadge(data.filter(v=> !v.read).length);


            }).catch(()=>{

                //window.location.replace(`/${demoPages.login.path}`)
            })
        },
    }))